// extracted by mini-css-extract-plugin
export var downArrow = "_hr-0";
export var infoTooltipIcon = "_hr-3";
export var label = "_hr-1";
export var optionCard = "_hr-4";
export var upArrow = "_hr-2";